import Joi from 'joi';

export const MinisterSchema = Joi.object({
  prefix: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  photo: Joi.string().required(),
});
